export var CHECKABLE_LIST_ITEM = 'checkable-list-item'; // https://github.com/facebook/draft-js/blob/master/src/model/constants/DraftBlockType.js#L27-L28

export var UNORDERED_LIST_ITEM = 'unordered-list-item';
export var ORDERED_LIST_ITEM = 'ordered-list-item';